import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const checkPackageSubscriptionOffer = (
  storeId,
  storeCustomerId,
  data,
) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/check-package-subscription-offer',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const setPackageSubscriptionOfferDefault = (
  brandId,
  storeId,
  subscriberId,
) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' +
      subscriberId +
      '/default',
    headers: getHeaders()
  });
};

export const setOrderPackageSubscription = (
  storeId,
  storeCustomerId,
  orderId,
  data
) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/order-package-subscription',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};